module.exports = __webpack_public_path__ + "img/14_fineStaff_lxb.81b768d0.png";